module.exports = __webpack_public_path__ + "static/media/Why Us.e1fad6fc.jpg";